import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../register.css";
import moment from "moment";


const ValidateEditor = (props) => {
    const [address, setAddress] = React.useState(props.address);
    const [value, setValue] = React.useState();

    const handleChange = (e) => {
        const newValue = e.currentTarget.value;
        setAddress((a) => ({ ...a, checkcode: newValue, checkvalidate: true, checkdate: moment.utc().add(-6, 'hours').format("YYYY-MM-DDTHH:mm:ss") }));
    }

    return (
        <div>
            <br />
            <br />
            <div className="p_summary">
                Please insert code number that you have received on request address and click on button to check if is valid.
            </div>
            <br />
            <br />
            <br />
            <br />
            <form>
                <div className="row">
                    <div className="col-6">
                        <label htmlFor="alertLevel">Insert Code :</label>
                    </div>
                    <div className="col-6">
                        <input className="input-table " name="checkcode" value={value} style={{ padding: "0px;" }} onChange={(e) => { handleChange(e); }} />
                    </div>

                </div>
                <br />
                <br />
                <br />
                <br />
                <div className="row">
                    <div className="col-6">
                        <button type='button' className="btn btn-info" onClick={() => props.onRequestSaveCode(address)}>Save</button> &nbsp;
                </div>
                    <div className="col-6" style={{ textAlign: "right" }}>
                        <button type='button' className="btn btn-info" onClick={() => props.onRequestCancel(address)}>Cancel</button>
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
            </form>
        </div>
    );
}

export { ValidateEditor }